export const VALIDATION_TEXT = {
  'alreadyRegistered': 'E-mail já cadastrado!',
  'invalid': 'E-mail inválido!',
  'success': 'E-mail adicionado!'
}

export const NEWSLETTER_FORM = {
  'button': 'Ok',
  'placeholder': 'Seu e-mail',
  'title': 'Receba nossa newsletter'
}

export const ERROR_CODES = {
  'EMAIL_JA_CADASTRADO': 'EMAIL_JA_CADASTRADO'
}
